import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';
import type { TrainingCourseDetail } from '~/types/academy/baseTraining';

function academyTrainingRequestUrl(identifier: string): string {
    return `/api/academy/docebo/${encodeURIComponent(identifier)}`;
}

export function useAcademyTraining(identifier: MaybeRefOrGetter<string>) {
    const requestUrl = computed(() => academyTrainingRequestUrl(toValue(identifier)));

    return useFetch<TrainingCourseDetail>(requestUrl, {
        credentials: 'include',
        server: false
    });
}
